export const fmtCurrency = (n, opts = {}) => {
  if (n === null || n === undefined) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: opts.max ?? 0,
  }).format(n);
};

export const fmtDistance = (miles) => {
  if (miles === null || miles === undefined) return '—';
  return `${Math.round(miles * 10) / 10} mi`;
};

export const fmtDriveTime = (minutes) => {
  if (!minutes) return null;
  if (minutes < 60) return `${Math.round(minutes)} min drive`;
  const h = Math.floor(minutes / 60);
  const m = Math.round(minutes % 60);
  return `${h}h ${m}m drive`;
};

export const timeAgo = (iso) => {
  if (!iso) return '—';
  const then = new Date(iso).getTime();
  const secs = Math.round((Date.now() - then) / 1000);
  if (secs < 60) return `${secs}s ago`;
  const mins = Math.round(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 48) return `${hrs}h ago`;
  const days = Math.round(hrs / 24);
  return `${days}d ago`;
};

export const opportunityMeta = (label) => {
  switch (label) {
    case 'strong_pickup': return { text: 'Strong Pickup', klass: 'op-strong' };
    case 'worth_reviewing': return { text: 'Worth Reviewing', klass: 'op-worth' };
    case 'moderate': return { text: 'Moderate', klass: 'op-mod' };
    case 'low_priority': return { text: 'Low Priority', klass: 'op-low' };
    default: return { text: 'Unrated', klass: 'op-low' };
  }
};

export const strategyLabel = (s) => ({
  repair_and_resell: 'Repair & Resell',
  sell_as_is: 'Sell As-Is',
  part_out: 'Part Out',
  scrap: 'Scrap',
  recycle: 'Recycle',
  donate: 'Donate',
  trade: 'Trade',
  consign: 'Consign',
  auction: 'Auction',
  sell_to_local_buyer: 'Local Buyer',
  pass: 'Pass on flipping',
}[s] || s);
